import { LuCopy, LuGripVertical, LuTrash2 } from "react-icons/lu";
import { formEl } from "../../../../constants";
import input from "../input.module.css";
import ImageSelect from "../../../../Components/ImageSelect/ImageSelect.jsx";
const RatingScale = ({
  item,
  handleValue,
  deleteEl,
  handleRequired,
  handleElType,
  handleOptionValues,
  duplicateElement,
  handleMinMax,
  disableDelete,
  isPreview = false,
}) => {

  return (
    <div className="bg-white drag-handle border border-gray-200 rounded-lg shadow-sm mb-4">
      <div className="text-center py-2 cursor-move">
        <LuGripVertical className="inline-block text-gray-400" size={20} />
      </div>
      <div className="px-6 space-x-4 py-4">
        <div className="space-y-4 gap-2">
          <div className="w-[300px]">
             <ImageSelect
            value={item.type}
            onChange={(value) => handleElType(item.id, value)}
            options={formEl}
            className={`${input.input_field} w-full`}
            disabled={isPreview}
          />
          </div>
          <div className="flex-1">
            <input
              type="text"
              defaultValue={item.value}
              onBlur={(e) => !isPreview && handleValue(item.id, e)}
              placeholder="Question"
              required={item.required}
              className={input.input_field}
              disabled={isPreview}
            />
            <div className="flex gap-4 mb-3">
              <div className="flex-1">
                <label className="block text-xs text-gray-600 mb-1">
                  Min. Rating Scale *
                </label>
                <input
                  type="number"
                  min="1"
                  value={item.min || 1}
                  onChange={(e) =>
                    !isPreview && handleMinMax(
                      item.id,
                      parseInt(e.target.value),
                      item.max || 5,
                    )
                  }
                  className={input.input_field}
                  disabled={isPreview}
                />
              </div>
              <div className="flex-1">
                <label className="block text-xs text-gray-600 mb-1">
                  Max. Rating Scale *
                </label>
                <input
                  type="number"
                  min="1"
                  value={item.max || 5}
                  onChange={(e) =>
                    !isPreview && handleMinMax(
                      item.id,
                      item.min || 1,
                      parseInt(e.target.value),
                    )
                  }
                  className={input.input_field}
                  disabled={isPreview}
                />
              </div>
            </div>
            {item.options &&
              item.options.length > 0 &&
              item.options.map((opt, key) => (
                <div key={opt?.id}>
                  <div>
                    <label className={input.input_title}>
                      Option {opt?.value} *
                    </label>
                  </div>
                  <div className="flex items-center gap-2 mb-2">
                    <div className="flex items-center gap-2 flex-1">
                      <input type="radio" disabled className="w-4 h-4" />
                      <input
                        type="text"
                        defaultValue={opt?.value}
                        onBlur={(e) =>
                          !isPreview &&
                          handleOptionValues(item?.id, opt?.id, e.target.value)
                        }
                        className={input.input_field}
                        disabled={isPreview}
                      />
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <hr className="border-gray-200" />
      <div className="flex items-center px-4 py-2 gap-4">
        <button
          onClick={() => deleteEl(item.id)}
          disabled={disableDelete || isPreview}
          className="text-red-500 hover:text-red-700 p-2"
          title="Delete Element"
        >
          <LuTrash2 size={18} />
        </button>
        <button
          onClick={() => duplicateElement(item.id, item.type)}
          disabled={isPreview}
          className="text-gray-600 hover:text-gray-800 p-2"
          title="Duplicate Element"
        >
          <LuCopy size={18} />
        </button>
        <label className="flex items-center gap-2 ml-auto cursor-pointer">
          <input
            type="checkbox"
            checked={item.required}
            onChange={() => handleRequired(item.id)}
            className="w-4 h-4"
            disabled={isPreview}
          />
          <span className="text-sm">Compulsory</span>
        </label>
      </div>
    </div>
  );
};

export default RatingScale;
